<template>
	<filter-value-bubble v-for="value in model" :key="value" :label="label_for(value)" @remove="remove(value)" />
</template>

<script setup>
import FilterValueBubble from './_filter-value-bubble.vue';

const props = defineProps({
	options: {
		type: Array,
		required: true,
	},
});

const emit = defineEmits([`change`]);

const model = defineModel({
	type: Array,
	default: () => [],
});

function label_for(value) {
	const match = props.options.find((option) => option.value === value);

	return match ? match.label : value;
}

function remove(value) {
	model.value = model.value.filter((item) => item !== value);

	emit(`change`);
}
</script>
